export const title = 'Welcome to TeamCity 2025.11'
export const subtitle = 'Meet AI Assistant in Early Access  🎉'
export const text =
  'TeamCity AI Assistant is your 24/7 companion that aims to help both beginners and experts, from offering general guidance on TeamCity concepts to delivering troubleshooting insights for misconfigured or failing builds.'
export const subText = 'This functionality is available for TeamCity Enterprise instances.'
export const callToActionLink = 'https://www.jetbrains.com/help/teamcity/2025.11/ai-assistant.html'
export const callToActionLabel = 'Learn more'
export const adminSettingLink = '/admin/admin.html?item=ai-assistant'
